import l from '../../../../../lang';
import TooltipIcon from '../../../../common/tooltip-icon';
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/info-unfilled.svg';
import { TransactionTaxes } from '../../../../../store/transactions/interfaces';
import { formatTaxAmount } from './taxes-utils';

interface WithholdingsRowProps {
  taxes?: TransactionTaxes | null;
}

const WithholdingsRow = ({ taxes }: WithholdingsRowProps) => {
  if (!taxes || !(Number(taxes.totalWithholdings) > 0)) {
    return null;
  }

  return (
    <div className="transaction_detail__box_detail__row transaction_detail__box_detail__row--withholding">
      <div className="transaction_detail__box_detail__row__label">
        <div className="transaction_detail__box_detail__row__label__text">{l('transactions.withholdings')}</div>
        <TooltipIcon placement="bottom" text={l('transactions.details.withholdings.tooltip')} icon={<InfoIcon />} />
      </div>
      <div className="transaction_detail__box_detail__row__value">
        {formatTaxAmount(taxes.withholdingsCurrency, taxes.totalWithholdings, true)}
      </div>
    </div>
  );
};

export default WithholdingsRow;
